import api from './api';

export const districtService = {
  // Get all districts
  async getDistricts() {
    try {
      const response = await api.get('/address/districts');
      return response.data;
    } catch (error) {
      console.error('Error fetching districts:', error);
      throw error;
    }
  },

  // Get subdivisions by district
  async getSubdivisions(getBy, districtCodeOrId) {
    try {
      const response = await api.get(`/address/subdivisions/${getBy}/${districtCodeOrId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching subdivisions:', error);
      throw error;
    }
  },

  // Get blocks by subdivision
  async getBlocks(subdivisionId) {
    try {
      const response = await api.get(`/address/blocks/${subdivisionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching blocks:', error);
      throw error;
    }
  },

  // Get GPUs by block
  async getGPUs(blockId) {
    try {
      const response = await api.get(`/address/gpus/${blockId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching GPUs:', error);
      throw error;
    }
  },

  // Get wards by GPU
  async getWards(gpuId) {
    try {
      const response = await api.get(`/address/wards/${gpuId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching wards:', error);
      throw error;
    }
  },

  // Get district by code
  async getDistrictByCode(districtCode) {
    try {
      const response = await api.get(`/address/district/${districtCode}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching district by code:', error);
      throw error;
    }
  },

  // Get subdivision by ID
  async getSubdivisionById(subdivisionId) {
    try {
      const response = await api.get(`/address/subdivision/${subdivisionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching subdivision by ID:', error);
      throw error;
    }
  },

  // Get block by ID
  async getBlockById(blockId) {
    try {
      const response = await api.get(`/address/block/${blockId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching block by ID:', error);
      throw error;
    }
  },

  // Get GPU by ID
  async getGPUById(gpuId) {
    try {
      const response = await api.get(`/address/gpu/${gpuId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching GPU by ID:', error);
      throw error;
    }
  },

  // Get ward by ID
  async getWardById(wardId) {
    try {
      const response = await api.get(`/address/ward/${wardId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching ward by ID:', error);
      throw error;
    }
  },

  // Add new district
  async addDistrict(districtData) {
    try {
      const response = await api.post('/address/add/district', districtData);
      return response.data;
    } catch (error) {
      console.error('Error adding district:', error);
      throw error;
    }
  },

  // Add new subdivision
  async addSubdivision(subdivisionData) {
    try {
      const response = await api.post('/address/add/subdivision', subdivisionData);
      return response.data;
    } catch (error) {
      console.error('Error adding subdivision:', error);
      throw error;
    }
  },

  // Add new block
  async addBlock(blockData) {
    try {
      const response = await api.post('/address/add/block', blockData);
      return response.data;
    } catch (error) {
      console.error('Error adding block:', error);
      throw error;
    }
  },

  // Add new GPU
  async addGPU(gpuData) {
    try {
      const response = await api.post('/address/add/gpu', gpuData);
      return response.data;
    } catch (error) {
      console.error('Error adding GPU:', error);
      throw error;
    }
  },

  // Add new ward
  async addWard(wardData) {
    try {
      const response = await api.post('/address/add/ward', wardData);
      return response.data;
    } catch (error) {
      console.error('Error adding ward:', error);
      throw error;
    }
  },
};

export default districtService;
